module.exports = __webpack_public_path__ + "static/media/mission-list-header.4222e183.png";